import { ReactComponent as FdicShieldIcon } from '@Assets/icons/fdic-shield.svg';
import { ReactComponent as TrustpilotStarIcon } from '@Assets/icons/trustpilot-star.svg';

export const TrustBadges = () => {
  return (
    <div className='flex items-center justify-between sm:justify-center w-full sm:w-auto sm:gap-[32px]'>
      <FdicShieldIcon />
      <TrustpilotStarIcon />
    </div>
  );
};
